import { DateTimeRange } from '@modules/common/components/DateRangePicker/types';

export const getHasGlobalFilterDurationChangedFromDefault = (
  duration: DateTimeRange | undefined,
) => {
  return duration !== undefined;
};
